import {Mapper} from '@s-ui/domain'

const eventMapping = {
  error: {
    'login-mt': 'login-error',
    'register-mt': 'register-error',
    'forgot-password-mt': 'forgot-password-error',
    'reset-password-mt': 'password-reset-error',
    'gigya-link-account-screen': 'link-account-error'
  },
  afterScreenLoad: {
    'login-mt': 'login',
    'register-mt': 'register',
    'forgot-password-mt': 'forgot-password',
    'reset-password-mt': 'password-reset',
    'register-success-mt': 'register-success',
    'forgot-password-sent-mt': 'forgot-password-send',
    'reset-password-success-mt': 'password-reset-success'
  }
}

const validationEventMapping = {
  afterValidation: {
    'register-mt': 'register-validation-error',
    'gigya-complete-registration-screen': 'complete-registration-error'
  }
}

export default class GigyaEventToPageNameAuthenticationMapper extends Mapper {
  _isEventAllowed = (gigyaEventName, gigyaScreenSet) =>
    Object.keys(eventMapping).includes(gigyaEventName) &&
    Object.keys(eventMapping[gigyaEventName]).includes(gigyaScreenSet)

  _isValidationEventAllowed = (gigyaEventName, gigyaScreenSet, errorCode) =>
    errorCode &&
    Object.keys(validationEventMapping).includes(gigyaEventName) &&
    Object.keys(validationEventMapping[gigyaEventName]).includes(gigyaScreenSet)

  map = ({gigyaEvent}) => {
    const gigyaEventName = gigyaEvent.getEventName()
    const gigyaScreenSet = gigyaEvent.getScreenSet()
    const errorCode = gigyaEvent.getErrorCode()

    const isEventAllowed = this._isEventAllowed(gigyaEventName, gigyaScreenSet)
    const isValidationeventAllowed = this._isValidationEventAllowed(gigyaEventName, gigyaScreenSet, errorCode)

    if (isEventAllowed) {
      return eventMapping[gigyaEventName][gigyaScreenSet]
    }

    if (isValidationeventAllowed) {
      return validationEventMapping[gigyaEventName][gigyaScreenSet]
    }
  }
}
